import { createContext } from 'react';
import { CollectionsContextProps } from './interfaces/collections-context-props-interface';

const CollectionsContext = createContext<CollectionsContextProps>({} as CollectionsContextProps);

export default CollectionsContext;
